export const hasApensado = (data, next, complete) => {
  return Boolean(data?.apensado || next?.apensado || complete?.apensado);
};

export const isParentApensadoProcess = (data, next, complete) => {
  const isParent = (item) => item?.apensado === true && !item?.apensado_id;

  return Boolean(isParent(data) || isParent(next) || isParent(complete));
};

// Planos que, por enquanto, se comportam exatamente como o Essencial.
// O "2026" (novo modelo de vendas, 22/09/2026) nasceu assim e será
// diferenciado depois — espelha SalesScope::PLANOS_COMO_ESSENCIAL na API.
export const PLANOS_COMO_ESSENCIAL = ["ESSENTIAL", "PLAN_2026"];

export const isPlanoComoEssencial = (familyPlan) =>
  PLANOS_COMO_ESSENCIAL.includes(familyPlan);

// No plano 2026 a taxa da conservatória é paga pelo cliente (com a equipe,
// pelo WhatsApp) — o card de Despacho muda por causa disso.
export const isPlano2026 = (familyPlan) => familyPlan === "PLAN_2026";

// Selo de apostila de cada documento, pelo nome: só a procuração dispensa a
// apostila. No Essencial/2026 quem apostila é o cliente; nos demais, a CJ.
export const seloApostila = (nomeDocumento, familyPlan) => {
  if (/procura[çc][ãa]o/i.test(nomeDocumento || "")) {
    return { tipo: "nao", texto: "Não precisa de apostila" };
  }
  if (isPlanoComoEssencial(familyPlan)) {
    return { tipo: "sim", texto: "Precisa de apostila" };
  }
  return { tipo: "cj", texto: "A CJ apostila por você" };
};

// Dias úteis (seg–sex) entre a data prevista e hoje. 0 se ainda não passou.
export const diasUteisDeAtraso = (dataPrevista) => {
  if (!dataPrevista) return 0;
  const [ano, mes, dia] = String(dataPrevista).slice(0, 10).split("-").map(Number);
  if (!ano || !mes || !dia) return 0;

  const cursor = new Date(ano, mes - 1, dia);
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);

  let dias = 0;
  while (cursor < hoje) {
    cursor.setDate(cursor.getDate() + 1);
    const semana = cursor.getDay();
    if (semana !== 0 && semana !== 6) dias += 1;
  }
  return dias;
};

// O aviso "em no máximo 2 dias úteis" só vale logo depois do prazo. Passado
// isso, o card troca a promessa por um texto sem prazo (a previsão já não
// representa a realidade e repetir "2 dias" por meses perde a confiança).
export const ATRASO_TOLERADO_DIAS_UTEIS = 2;

export const isAtrasoLongo = (dataPrevista) =>
  diasUteisDeAtraso(dataPrevista) > ATRASO_TOLERADO_DIAS_UTEIS;

// Quando o Airtable registra a chegada de um documento com o reference_id de
// outro modelo de lista (ex.: "RG, CNH" x "RG, CIN, CNH"), a API cria um
// documento novo em vez de atualizar o existente, e o card mostra o mesmo
// documento duas vezes com status diferentes. Aqui fica um por nome + de quem
// é, mantendo o de status mais avançado (na ordem em que apareceu primeiro).
const PESO_STATUS_DOCUMENTO = {
  ARRIVED_SUCCESSFULLY: 3,
  ARRIVED_WRONG: 2,
  NOT_REQUIRED: 1,
  PENDING: 0,
};

const chaveDocumento = (doc) =>
  [
    String(doc?.name || "")
      .replace(/,\s*CIN\b/i, "")
      .trim()
      .toLowerCase(),
    String(doc?.from_who || "").trim().toLowerCase(),
  ].join("|");

export const documentosSemDuplicata = (documentos) => {
  if (!Array.isArray(documentos)) return documentos;

  const escolhido = new Map();
  documentos.forEach((doc) => {
    const chave = chaveDocumento(doc);
    const atual = escolhido.get(chave);
    const peso = PESO_STATUS_DOCUMENTO[doc?.status] ?? 0;
    const pesoAtual = atual ? PESO_STATUS_DOCUMENTO[atual?.status] ?? 0 : -1;
    if (peso > pesoAtual) escolhido.set(chave, doc);
  });

  const vistos = new Set();
  return documentos.reduce((lista, doc) => {
    const chave = chaveDocumento(doc);
    if (vistos.has(chave)) return lista;
    vistos.add(chave);
    lista.push(escolhido.get(chave));
    return lista;
  }, []);
};

export const isEssentialPlanProcess = (data, next, complete) => {
  return [data, next, complete].some((item) =>
    isPlanoComoEssencial(item?.sale?.family_plan)
  );
};
